import { Component } from '@angular/core';

@Component({
  selector: 'app-no-access',
  standalone: false,
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.css']
})
export class NoAccessComponent { }
